import { render, staticRenderFns } from "./DisplayExample.vue?vue&type=template&id=0f991842&scoped=true&"
import script from "./DisplayExample.vue?vue&type=script&lang=js&"
export * from "./DisplayExample.vue?vue&type=script&lang=js&"
import style0 from "./DisplayExample.vue?vue&type=style&index=0&id=0f991842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f991842",
  null
  
)

export default component.exports